






import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ChatbotMsg } from '../models/ChatbotMsg';
import  ChatbotMessageFeedbackEl from './feedback/ChatbotMessageFeedbackEl.vue';
@Component({
    components: {
      ChatbotMessageFeedbackEl
    }
})
export default class ChatbotMessageActions extends Vue {
  @Prop({default: null}) message: ChatbotMsg
  pendingFeedback: boolean = false;
   
}
